import React, { useEffect, useState } from 'react';
import Dialog from '../../GenericComponents/dialog';
import { FoundationsButton } from '../../GenericComponents/button';
import { FoundationsInput } from '../../GenericComponents/input';
import { useForm } from 'react-hook-form';
import { FormValidation } from '../../FormValidationsRules';
import { passwordValidate } from '../../Utils';
import { User } from '../../Redux/Admin_Tasks/userAccountSlice';
import { FoundationsForm } from '../../GenericComponents/form';
import { UsersbyStatus, useSavePasswordSettingsMutation } from '../../Redux/Admin_Tasks/userAccountSlice';
import { encryptData } from '../../GlobalMethods';
import { useSelector } from 'react-redux';
import { getAppSettings,  RootState } from '../../Redux/store'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster';
interface ChangePasswordProps {
    isOpen: boolean;
    userId?: number | null;
    userByStatus?: UsersbyStatus;
    onClose: () => void;
}
export interface PasswordData {
    Password: string
    ReenterPassword: string
    ForceUserToChangePassword: boolean
    emailAddress: string
}

const ChangePassword: React.FC<ChangePasswordProps> = ({
    isOpen,
    userId,
    userByStatus,
    onClose
}) => {
   
    const [fullName, setFullName] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [isPasswordFormVisible, setPasswordFormVisible] = useState(false)
    const appSettings: any = useSelector(
        (state: RootState) => { return getAppSettings(state) }
    )
    const [PasswordData, setPasswordData] = useState<PasswordData>({
        emailAddress: emailAddress,
        Password: '',
        ReenterPassword: '',
        ForceUserToChangePassword: false,
       
    })

    const {
        register: register,
        handleSubmit: handleSubmit,
        formState: { errors },
        trigger,
        reset,
    } = useForm<PasswordData>();

    const [
        SavePasswordSettings,
        { isLoading: passwordLoading },
    ] = useSavePasswordSettingsMutation()

    const [GeneralData, setGeneralData] = useState<Pick<User, 
            'FirstName' | 'LastName' | 'OrganizationName' | 'NationalProviderID' | 'DeveloperMode'>>
        ({
            FirstName: '',
            LastName: '',
            OrganizationName: '- select a location -',
            NationalProviderID: '',
            DeveloperMode: false,
    });

    const handlePasswordSettings = (data: PasswordData) => {
        if (passwordLoading) {
            return
        }
        PasswordData.Password = encryptData(PasswordData.Password.trim(), appSettings.PublicEncryptionKey)
        PasswordData.ReenterPassword = encryptData(PasswordData.ReenterPassword.trim(), appSettings.PublicEncryptionKey)
        PasswordData.emailAddress = emailAddress;
        SavePasswordSettings(PasswordData)
            .unwrap()
            .then((response) => {
                if (response != null) {
                    var resultData = response.data
                    if (resultData != null && response.statusCode == 204) {
                        FoundationsGenericToaster('success', "Password for user account:  has been updated successfully.");
                        onClose();
                    } else {
                        FoundationsGenericToaster('error', 'Sorry, changes to general settings failed. Please try again.'
                        )
                    }
                }
            })
    }

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = e.target;
        setPasswordData((prevData) => ({
            ...prevData,
            ForceUserToChangePassword: checked,
        }));
    };

    const passwordsMatch = (val: string) => {
        if (PasswordData.Password != val) {
            return 'Your password and confirm password do not match.'
        } else {
            return true
        }
    }

    const handlePasswordInputChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setPasswordData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        await new Promise((resolve) => setTimeout(resolve, 0));
        await trigger(name as keyof PasswordData);
    };

    useEffect(() => {
    }, [userByStatus]);

    useEffect(() => {
        if (userByStatus?.usersData) {
            const user = userByStatus.usersData.find((user) => String(user.Id) === String(userId));
            if (user) {
                setFullName(user.FullName || '');
                setEmailAddress(user.EmailAddress || '');
                setGeneralData({
                    FirstName: user?.FirstName || '',
                    LastName: user?.LastName || '',
                    OrganizationName: user?.OrganizationName || '- select a location -',
                    NationalProviderID: user?.NationalProviderID || '',
                    DeveloperMode: user?.DeveloperMode ?? false,
                });
            }
        }
    }, [userByStatus, userId]);

    useEffect(() => {
        if (isOpen) {
            setPasswordData({
                emailAddress: emailAddress,
                Password: '',
                ReenterPassword: '',
                ForceUserToChangePassword: false,
            });
            reset({
                Password: '',
                ReenterPassword: '',
                ForceUserToChangePassword: false,
                emailAddress: emailAddress
            });
        }
    }, [isOpen, emailAddress, reset]);
    
    return (
        <Dialog
            isOpen={isOpen}
            title="Change User Password"
            width={500}
            height="auto"
            zIndex={101}
            onClose={onClose}
            buttons={[
                {
                    label: "Cancel",
                    id: "buttonPasswordCancelChanges",
                    onClick: onClose,
                    className: "ui-button ui-corner-all ui-widget app-button negative",
                },
                {
                    label: "Change Password",
                    id: "buttonPasswordSaveChanges",
                    onClick: handleSubmit(handlePasswordSettings), 
                    className: "ui-button ui-corner-all ui-widget app-button",
                    isLoading: passwordLoading,
                }
            ]}
        >
            <div id="change_user_password_wrapper">
                <table className="input-form-table-popup-window">
                    <tbody>
                        <tr>
                            <td className="left" style={{ width: '37%' }}>
                                <div>Name:</div>
                            </td>
                            <td className="right">
                                <div id="label_change_password_fullname" className="strong">{fullName}</div>
                            </td>
                        </tr>
                        <tr>
                            <td className="left">
                                <div>Email:</div>
                            </td>
                            <td className="right">
                                <div id="label_change_password_email" className="strong">{emailAddress}</div>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <div id="help_image_changepassword_password">
                                    <FoundationsForm
                                        id="password_form_el"
                                        submitFunction={handleSubmit(handlePasswordSettings)}
                                    >
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="left">
                                                        <div>Password:</div>
                                                    </td>
                                                    <td className="right">
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <FoundationsInput
                                                                    classes="form-group row field-user-change-password"
                                                                    id="text_change_password_password"
                                                                    type="password"
                                                                    name="Password"
                                                                    value={PasswordData.Password}
                                                                    maxLength={24}
                                                                    labelText=""
                                                                    errorClasses="col-12 text-left custom-error-style"
                                                                    labelClasses="col-sm-2 col-form-label"
                                                                    containerClasses="col-sm-11"
                                                                    ariaAutocomplete="none"
                                                                    toolTipText="• Must be at least 8 letters.<br/>• Must have at least one uppercase letter.<br/>• Must have at least one lowercase letter.<br/>• Must have at least one number.<br/>• Must have at least one special character from ~!@#$%^&*(),.+;:?"
                                                                    onInput={handlePasswordInputChange}
                                                                    registerFunction={register}
                                                                    registerName="Password"
                                                                    registerRules={{
                                                                        ...FormValidation.userAccountPassword,
                                                                        validate: (val: string) =>
                                                                            passwordValidate(val, GeneralData.FirstName, GeneralData.LastName),
                                                                    }}
                                                                    error={errors.Password?.message}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="left">
                                                        <div>Confirm Password:</div>
                                                    </td>
                                                    <td className="right">
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <FoundationsInput
                                                                    classes="form-group row field-user-change-password"
                                                                    id="text_change_password_reenterpassword"
                                                                    type="password"
                                                                    name="ReenterPassword"
                                                                    value={PasswordData.ReenterPassword}
                                                                    maxLength={24}
                                                                    labelText=""
                                                                    errorClasses="col-12 text-left"
                                                                    labelClasses="col-sm-2 col-form-label"
                                                                    containerClasses="col-sm-11"
                                                                    ariaAutocomplete="none"
                                                                    onInput={handlePasswordInputChange}
                                                                    registerFunction={register}
                                                                    registerName="ReenterPassword"
                                                                    registerRules={{
                                                                        ...FormValidation.confirmPassword,
                                                                        validate: passwordsMatch,
                                                                    }}
                                                                    error={errors.ReenterPassword?.message}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="left">
                                                        <div>Force User to change password:</div>
                                                    </td>
                                                    <td className="right">
                                                        <input
                                                            id="checkbox_force_change_password"
                                                            type="checkbox"
                                                            onChange={handleCheckboxChange}
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        {/* Loading Indicator */}
                                        <span id="change_password_loading"
                                          className={`ajax-loading-box popup-loading ${passwordLoading  ? '' : 'hide'}`}
                                         >
                                            <span className="ajax-loading-image">Saving...</span>
                                        </span>
                                    </FoundationsForm>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Dialog>
    );
}
export default ChangePassword;